<template>
  <div class="jm" v-if="kbxmlc">
    <!-- 主持人页面 -->
    <template v-if="role == 'Z'">
      <div v-if="sfkq === ''" class="box noBtn">
        <el-button type="primary kqjm" @click="setJmTime()">开启解密</el-button>
      </div>
      <template v-else>
        <div class="jmBtn">
          <div>
            <p>解密剩余时间</p>
            <myClock
              class="small lf"
              :shenyu="shenyu"
              :key="shenyu"
              cId="c1"
            ></myClock>
            <el-button
              type="primary redColor"
              @click="setJmTime()"
              v-if="kbxmlc.zt != '2'"
              >调整解密时间</el-button
            >
            <el-button
              type="primary redColor"
              @click="handleEnd()"
              v-if="kbxmlc.zt != '2' && time > 1000"
              >结束解密</el-button>
          </div>
        </div>

        <div
          class="clear"
          style="
            background: #f3f3f3;
            border: 1px solid #ddd;
            margin-bottom: 10px;
            line-height: 36px;
            padding: 5px 20px;
          "
        >
          <p class="lf">
            解密情况：<span :class="jmqk ? 'success' : 'red'"
              >{{ jmqk ? "已" : "未" }}全部完成解密</span
            >
          </p>
          <div class="rt">
            <el-badge :value="sqbjDcl" :max="99" class="rt">
              <el-button type="primary" @click="lookSqbj">补救申请</el-button>
            </el-badge>
          </div>
        </div>
        <div :class="['jmContent', kbxmlc.zt == '2' ? 'noBtn' : '']">
          <jmCom
            ref="jmCom"
            @Qd="saveJm"
            @ewmQd="ewmQd"
            @bj="bj"
            :jm="true"
            :list="list"
            :sfApp="sfApp"
          ></jmCom>
        </div>
        <div :class="[{ xyb: kbxm.zt == '4' }]" style="text-align: center">
          <el-button
            type="primary lcNext"
            :disabled="!isOk || waitLoading"
            @click="nextBtn"
            v-if="kbxmlc.zt != '2'"
            >下一步</el-button
          >
          <span class="red" style="margin-left: 10px" v-if="kbxm.zt == '4'"
            >第一阶段开标结束，等待评审结束后继续开第二阶段的标。</span
          >
        </div>
      </template>
   
    </template>
    <!-- 招标人页面 -->
    <template v-else>
      <div class="jmBtn">
        <div v-if="sfkq === ''" class="ddjm">等待开启解密</div>
        <div v-else>
          <p>解密剩余时间</p>
          <myClock
            class="small lf"
            :shenyu="shenyu"
            :key="shenyu"
            cId="c1"
          ></myClock>
        </div>
      </div>
      <div class="jmContent zbrBox">
        <div class="clear">
          <p class="cont-title lf">解密</p>
          <div class="rt">
            <el-input
              v-model="tbdwmc"
              class="input-with-select lf"
              style="width: 250px; margin: 0 10px"
              placeholder="投标单位名称"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getData"
              ></el-button>
            </el-input>
            <el-badge :value="sqbjDcl" :max="99" class="rt">
              <el-button type="primary" @click="lookSqbj">补救申请</el-button>
            </el-badge>
            <!-- <el-button
              type="primary rt"
              @click="getPfjgTabs"
              style="margin-right: 10px"
              v-if="sfeckb"
              >显示评分结果</el-button
            > -->
          </div>
        </div>
        <el-table
          ref="table"
          border
          :data="tableData"
          style="width: 100%"
          max-height="450px"
        >
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column
            prop="fCQYMC"
            label="投标单位名称"
            show-overflow-tooltip
            min-width="170"
          ></el-table-column>
          <el-table-column
            prop="fDBSSCSJ"
            label="投标文件递交时间"
            sortable
            width="165"
          ></el-table-column>
          <el-table-column prop="jmff" label="解密方式" width="100">
            <template slot-scope="scope">
              <template v-if="scope.row.jmff == null"></template>
              <template v-if="scope.row.jmff == '0'">正常</template>
              <span v-if="scope.row.jmff == '1'" class="warning">补救</span>
            </template>
          </el-table-column>
          <el-table-column prop="jmzt" label="解密状态" width="100">
            <template slot-scope="scope">
              <template v-if="scope.row.jmzt == '0'"></template>
              <template v-if="scope.row.jmzt == '1'">成功</template>
              <span v-if="scope.row.jmzt == '2'" class="red">失败</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="jmsj"
            label="解密时间"
            sortable
            width="180"
            :formatter="jmsjFormatter"
          ></el-table-column>
        </el-table>
        <div class="clear">
          <span class="lf pageNum"
            >共{{ total }}家，已解密{{ yjm }}家，待解密{{ djm }}家。</span
          >
        </div>
      </div>
    </template>

    <!-- 设置解密时间 -->
    <el-dialog
      title="解密"
      :visible.sync="dialogVisible"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox">
        <p v-if="sfkq === ''">开启解密通道，默认解密时间1小时</p>
        <p v-else>调整解密截止时间</p>
        <div>
          <span>解密截止时间</span>
          <el-time-picker
            style="width: 180px"
            v-model="nowTime"
            value-format="HH:mm:ss"
            :clearable="false"
          >
          </el-time-picker>
        </div>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="saveJmTime" :disabled="waitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 补救 -->
    <el-dialog
      title="补救"
      :visible.sync="dialogBj"
      width="780px"
      :close-on-click-modal="false"
    >
      <div class="bjBox">
        <div class="bjdwmc">当前补救单位：{{ bjdwmc }}</div>
        <div class="clear">
          <globalUploader
            :disabled="uploadFlag"
            @fileAdded="fileAdded"
            @fileSuccess="fileSuccess"
          ></globalUploader>
        </div>
      </div>
      <div class="btnBox">
        <el-button
          type="primary"
          @click="saveBj"
          :disabled="!bidfilesId || waitLoading"
          >补救{{ bidfilesId }}</el-button
        >
        <el-button type="primary" @click="dialogBj = false">回到解密</el-button>
      </div>
    </el-dialog>
    <!-- 申请补救列表 -->
    <el-dialog
      title="补救申请"
      :visible.sync="sqbjDialog"
      width="780px"
      :close-on-click-modal="false"
    >
      <el-table ref="sqbjList" border :data="sqbjList" style="width: 100%">
        <el-table-column type="index" label="序号" width="50">
          <template slot-scope="scope">{{
            (sqbjPage - 1) * 10 + scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column prop="fCQYMC" label="投标单位名称" min-width="120">
          <template v-if="role == 'Z'">**********</template>
        </el-table-column>
        <el-table-column prop="jmzt" label="解密失败" width="120">
          <template slot-scope="scope">
            <template v-if="scope.row.jmzt == '2'">是</template>
            <span v-else class="red">否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sqsj"
          label="申请时间"
          width="170"
          :formatter="sqbjFormatter"
        ></el-table-column>
        <el-table-column
          prop="sqbj"
          label="处理"
          width="120"
          v-if="role == 'Z'"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.sqbj == '1'"
              @click="sqbjJg('2', scope.row)"
              :disabled="waitLoading"
              >同意</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.sqbj == '1'"
              @click="sqbjJg('3', scope.row)"
              :disabled="waitLoading"
              >拒绝</el-button
            >
            <span v-if="scope.row.sqbj == '2'" class="success">已同意</span>
            <span v-if="scope.row.sqbj == '3'" class="red">已拒绝</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="clear">
        <span class="lf pageNum"
          >共{{ sqbjTotal }}家，已处理{{ sqbjTotal - sqbjDcl }}家，待处理{{
            sqbjDcl
          }}家。</span
        >
        <!-- <myPage
          class="rt"
          :total="sqbjTotal"
          :page-size="10"
          :currentPage="sqbjPage"
          @changePage="changeSqbjPage"
        ></myPage> -->
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="sqbjDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 评分结果 -->
    <el-dialog
      title="评分结果"
      :visible.sync="pfjgDialog"
      width="980px"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="item in pfjgTabs"
          :label="item.nodeName"
          :name="item.nodeName"
          :key="item.id"
        >
          <el-table
            ref="pfjgList"
            border
            :data="pfjgList"
            style="width: 100%"
            empty-text="评审未完成，请稍等。。"
          >
            <el-table-column type="index" label="序号" width="50">
              <template slot-scope="scope">{{
                (pfjgPage - 1) * 10 + scope.$index + 1
              }}</template>
            </el-table-column>
            <el-table-column
              prop="tenderName"
              label="投标单位名称"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="score"
              label="得分"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="isPass"
              label="有效"
              width="80"
            >
              <template slot-scope="scope">{{ scope.row.isPass === 1 ? '通过' : '未通过' }}</template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              min-width="120"
            ></el-table-column>
          </el-table>
          <div class="clear">
            <span class="lf pageNum">共{{ pfjgTotal }}家。</span>
            <!-- <myPage
              class="rt"
              :total="pfjgTotal"
              :page-size="10"
              :currentPage="pfjgPage"
              @changePage="changePfjgPage"
            ></myPage> -->
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="btnBox">
        <el-button type="primary" @click="handleExport" :disabled="waitLoading"
          >导出报表</el-button
        >
        <el-button type="primary" @click="pfjgDialog = false">确认</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import myClock from "../components/clock/clock";
import jmCom from "../components/jmCom";
import globalUploader from "../components/upload/uploader";
import { exportFile } from '@/utils';

export default {
  name: "jm",
  components: {
    myClock,
    jmCom,
    globalUploader,
  },
  data() {
    return {
      kbxmlc: "",
      kbxm: "",
      djlcId: "",
      sfkq: "", //是否已经开启过解密按钮
      shenyu: 0,
      time: 0,
      tbdwmc: "", //查询条件
      tableData: [],
      djm: 0, //待解密家数
      isOk: false, //是否可以下一步
      dialogVisible: false, //设置解密时间弹窗
      jmTime: "",
      nowTime: "",
      dialogBj: false, //补救弹窗
      bjdwmc: "", //
      uploadFlag: false, //上传按钮是否禁用
      fileList: [],
      fileName: "",
      bidfilesId: "", //保存补救时要用
      tbwjId: "",
      intervalJm: null, //倒计时
      list: [],
      sfApp: "",
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      sqbjDialog: false,
      sqbjList: [],
      sqbjPage: 1,
      sqbjTotal: 0,
      sqbjDcl: 0,
      jmqk: false, //是否全部解密
      sfeckb: false, //是否二次开标，显示评分按钮是否显示
      pfjgDialog: false,
      pfjgTabs: [],
      activeName: "", //评分结果类型
      pfjgMap: {},
      pfjgList: [],
      pfjgPage: 1,
      pfjgTotal: 0,
      waitLoading: false,
    };
  },
  computed: {
    yjm() {
      return this.total - this.djm; //已解密家数
    },

    sectionId() {
      return localStorage.getItem('bdId') || null
    }
  },
  methods: {
    getData(lx) {
      let para = {
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
        lx: lx,
      };
      this.waitLoading = true;
      clearTimeout(this.intervalJm);
      this.intervalJm = null;
      this.$api
        .tbdwJmList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableData = res.data.data.tbdwList;
            this.kbxm = res.data.data.kbxm;
            this.total = res.data.data.total;
            this.djm = res.data.data.wjmSize;
            this.sfkq = res.data.data.sfszjmsj;
            this.isOk = res.data.data.sfxyb;
            this.jmqk = res.data.data.jmqk;
            this.kbxmlc = res.data.data.kbxmlc;
            this.list = res.data.data.tbwjList;
            this.sfApp = res.data.data.sfApp;
            this.sfeckb = res.data.data.xsbb;
            if (this.sfkq !== "") {
              this.shenyu = res.data.data.sfszjmsj;
              //this.shenyu=5000
              this.time = this.shenyu;
              if (this.shenyu >= 1000) {
                this.jmshenyuFun();
              }
            }
            this.waitLoading = false;
          } else {
            this.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    //开启解密
    setJmTime() {
      var hh =
        new Date().getHours() + 1 > 10
          ? new Date().getHours() + 1
          : new Date().getHours() + 1;
      var mm =
        new Date().getMinutes() > 10
          ? new Date().getMinutes()
          : "0" + new Date().getMinutes();
      var ss =
        new Date().getSeconds() > 10
          ? new Date().getSeconds()
          : "0" + new Date().getSeconds();
      this.nowTime = String(hh) + ":" + String(mm) + ":" + String(ss);
      this.dialogVisible = true;
    },
    //确认解密时间
    saveJmTime() {
      var t = new Date();
      var y = t.getFullYear();
      var M =
        t.getMonth() + 1 > 10 ? t.getMonth() + 1 : "0" + (t.getMonth() + 1);
      var d = t.getDate() > 10 ? t.getDate() : "0" + t.getDate();
      let para = {
        jmsj: y + "-" + M + "-" + d + " " + this.nowTime,
      };
      this.waitLoading = true;
      this.$api
        .kqjm(para)
        .then((res) => {
          if (res.data.meta.success) {
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
            this.dialogVisible = false;
            this.waitLoading = false;
            this.getData(1);
          } else {
            this.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    saveJm(obj) {
      this.$refs.jmCom.waitLoading = true;
      let tbdw = obj;
      let para = {
        jmmw: tbdw.jmmw,
        caNo: tbdw.caNo,
        sftbr: false,
      };
      this.waitLoading = true;
      this.$api
        .checkJm(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.$message({
              type: "success",
              message: "解密成功！",
            });
            let obj = {
              lx: "zb",
              data: {
                id: res.data.data.qyjgdm,
              },
            };
            this.$emit("send", JSON.stringify(obj));
            this.waitLoading = false;
            this.$refs.jmCom.waitLoading = false;
          } else {
            this.waitLoading = false;
            this.$refs.jmCom.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.form.password = "";
          this.$refs.jmCom.waitLoading = false;
        })
        .catch(() => {});
    },
    //补救弹窗
    bj() {
      this.dialogBj = true;
      this.fileName = ""; //清空弹窗中保留的之前上传的文件名
      this.bidfilesId = "";
      this.bjdwmc = "";
      this.tbwjId = "";
    },
    saveBj() {
      let para = {
        tbwjId: this.tbwjId,
        bidfilesId: this.bidfilesId,
        sftbr: false,
      };
      this.waitLoading = true;
      this.$api
        .saveBj(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.$message({
              type: "success",
              message: "补救成功！",
            });
            this.dialogBj = false;
            this.bidfilesId = "";
            this.fileName = "";
            this.fileList = [];
            let obj = {
              lx: "zb",
              data: {
                id: res.data.data.jgdm, //*****************这个参数需要在上传文件成功后后台返回
              },
            };
            this.$emit("send", JSON.stringify(obj));
            this.waitLoading = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
            this.bidfilesId = "";
            this.fileName = "";
            this.fileList = [];
            this.waitLoading = false;
          }
        })
        .catch(() => {});
    },
    ewmQd(obj) {
      let para = {
        lx: "zb",
        data: {
          id: obj.jgdm,
        },
      };
      this.$emit("send", JSON.stringify(para));
    },
    //显示评分结果列表弹窗
    // handleClick(tab, event) {
    //   this.getPfjgList();
    // },
    // getPfjgTabs() {
    //   let para = {};
    //   this.$api
    //     .getPfjgTabs(para)
    //     .then((res) => {
    //       if (res.data.meta.success) {
    //         if (res.data.data.kbxmpsszList.length) {
    //           this.pfjgTabs = res.data.data.kbxmpsszList;
    //           this.activeName = this.pfjgTabs[0].lx;
    //           this.pfjgDialog = true;
    //           this.getPfjgList();
    //         } else {
    //           this.$message({
    //             type: "warning",
    //             message: "此项目无打分制评审!",
    //           });
    //         }
    //       } else {
    //         this.$message({
    //           type: "error",
    //           message: res.data.meta.messgae,
    //         });
    //       }
    //     })
    //     .catch(() => {});
    // },
    // getPfjgList() {
    //   let para = {
    //     pageSize: 10,
    //     currentPage: this.pfjgPage,
    //     lx: this.activeName,
    //   };
    //   this.$api
    //     .getPfjgList(para)
    //     .then((res) => {
    //       if (res.data.meta.success) {
    //         this.pfjgList = res.data.data.dfList;
    //         this.pfjgTotal = res.data.data.total;
    //       } else {
    //         this.$message({
    //           type: "error",
    //           message: res.data.meta.messgae,
    //         });
    //       }
    //     })
    //     .catch(() => {});
    // },
    // changePfjgPage(page) {
    //   this.pfjgPage = page;
    //   this.getPfjgList();
    // },
    // dcbb() {
    //   let para = {
    //     lx: this.activeName,
    //   };
    //   this.waitLoading = true;
    //   this.$api
    //     .dcpsjgb(para)
    //     .then((res) => {
    //       let fileName = decodeURI(
    //         res.headers["content-disposition"].split("=")[1]
    //       );
    //       let blob = new Blob([res.data]);
    //       if (window.navigator.msSaveOrOpenBlob) {
    //         navigator.msSaveBlob(blob, fileName);
    //       } else {
    //         var link = document.createElement("a");
    //         link.href = window.URL.createObjectURL(blob);
    //         link.download = fileName;
    //         link.click();
    //         //释放内存
    //         window.URL.revokeObjectURL(link.href);
    //       }
    //       this.waitLoading = false;
    //     })
    //     .catch(() => {});
    // },
    //显示补救列表弹窗
    lookSqbj() {
      this.sqbjDialog = true;
      this.sqbjPage = 1;
      this.getSqbjList();
    },
    getSqbjList() {
      let para = {
        pageSize: 10,
        currentPage: this.sqbjPage,
      };
      this.$api
        .getSqbjList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.sqbjList = res.data.data.tbdwList;
            this.sqbjDcl = res.data.data.sqbjCount;
            this.sqbjTotal = res.data.data.total;
          } else {
          }
        })
        .catch(() => {});
    },
    changeSqbjPage(page) {
      this.sqbjPage = page;
      this.getSqbjList();
    },
    sqbjJg(val, row) {
      let para = {
        sqjg: val,
        tbdwId: row.id,
      };
      this.$api
        .jssqbj(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.getSqbjList();
            let obj = {
              lx: "sqbjJg",
              data: {
                id: res.data.data.jgdm, //*****************这个参数需要后台返回
              },
            };
            this.$emit("send", JSON.stringify(obj));
          }
        })
        .catch(() => {});
    },
    nextBtn() {
      this.waitLoading = true;
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.$emit("nextBtn", para);
    },
    jmsjFormatter(row, column, cellValue, index) {
      if (row.jmsj) {
        return this.$moment(row.jmsj).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    sqbjFormatter(row, column, cellValue, index) {
      if (row.sqsj) {
        return this.$moment(row.sqsj).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    //计算剩余时间倒计时
    jmshenyuFun() {
      var _this = this;
      _this.intervalJm = setTimeout(function () {
        _this.time = _this.time - 1000;
        if (_this.time < 1000) {
          clearTimeout(_this.intervalJm);
          _this.intervalJm = null;
          _this.getData(22);
          return false;
        } else {
          _this.jmshenyuFun();
        }
      }, 1000);
    },
    fileAdded() {
      this.bidfilesId = "";
    },
    fileSuccess(obj) {
      console.log(obj,'---');
      this.bjdwmc = obj.tbdwmc;
      this.tbwjId = obj.tbwjId;
      this.bidfilesId = obj.bidfilesId;
    },

    // #region 显示评分结果
    getPfjgTabs() {
      const para = {
        sectionId: this.sectionId
      }
      this.$api.evaluationProcess(para).then(res => {
        if (!res.data?.success) throw new Error(res.data.message)

        this.pfjgTabs = res.data.data.filter(item => item.status == 2)
        if (!this.pfjgTabs.length) throw new Error('评审未完成，请稍后查看结果！')

        this.activeName = this.pfjgTabs[0].nodeName;
        this.getPfjgList();
        this.pfjgDialog = true;
      }).catch((err)=>{
        this.$message({
          type: 'error',
          message: err.message
        })
      })
    },
    getPfjgList() {
      const activeTab = this.pfjgTabs.find(item => item.nodeName === this.activeName)
      let para = {
        nodeType: activeTab.nodeType,
        sectionId: this.sectionId,
        pageSize: 99,
        page: 1,
      };
      this.$api
        .getPfjgList(para)
        .then((res) => {
          if (res.data.success) {
            this.pfjgList = res.data.data;
            this.pfjgTotal = this.pfjgList.length;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((err) => {
          console.error('getPfjgList fail', err)
        });
    },
    handleClick(tab, event) {
      this.getPfjgList();
    },
    async handleExport() {
      try {
        this.waitLoading = true;
        const activeTab = this.pfjgTabs.find(item => item.nodeName === this.activeName)
        const para = {
          nodeType: activeTab.nodeType,
          sequence: activeTab.nodeSequence,
          sectionId: this.sectionId
        };
        const res = await this.$api.getEvalResult(para)
        const fileName = activeTab.nodeName + '报表.docx';
        exportFile(res, fileName, [
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8'
        ])
        this.waitLoading = false;
      } catch (err) {
        console.error('getEvalResult fail', err);
        this.waitLoading = false;
      }
    },
    // #endregion

    // 专家手动触发结束解密
    async handleEnd() {
      try {
        const { data } = await this.$api.endDecryptionPrematurely()
        console.log('专家手动触发结束解密:', data)
        if (!data.meta.success) {
          this.$message({
            type: 'error',
            message: data.meta.message,
          })
          return
        }
        this.getData(22)
      } catch(err) {
        console.error('endDecryptionPrematurely fail', err)
      }
    }
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData(1);
    this.getSqbjList();
  },
  beforeDestroy() {
    clearTimeout(this.intervalJm);
    this.intervalJm = null;
  },
};
</script>
<style lang="less" scoped>
.jm {
  width: 100%;
  .kqjm.el-button {
    width: 350px;
    height: 55px;
    line-height: 55px;
    font-size: 20px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .jmBtn {
    height: 110px;
    background: #fdf0f3;
    border: 1px solid @border-color;
    border-top: 2px solid @base-color;
    margin-bottom: 10px;
    text-align: center;
    line-height: 108px;
    .ddjm {
      font-weight: bold;
      font-size: 32px;
      color: @base-color;
    }
    p {
      float: left;
      font-size: 20px;
      color: #333;
    }
    > div {
      width: 100%;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      
      .el-button.el-button--text {
        font-size: 16px;
      }
    }
  }
  .jmContent {
    border: 1px solid #ddd;
    background: @base-Bg;
    padding: 50px 0;
    height: calc(~"100% - 230px");
    width: 100%;
  }
  .jmContent.noBtn {
    height: calc(~"100% - 180px");
    width: 100%;
  }
  .jmContent.zbrBox {
    padding: 10px;
    height: calc(~"100% - 120px");
  }
  .dialogBox {
    padding: 50px 80px;
    p {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
    }
    span {
      font-size: 16px;
      color: #333;
      margin-right: 10px;
    }
  }
  .bjBox,
  .jmBox {
    padding: 0 20px 20px;
    .bjdwmc {
      font-size: 16px;
      color: #333;
      margin-bottom: 10px;
      height: 40px;
    }
    div.ca {
      width: 60%;
      padding-right: 30px;
      position: relative;
      float: left;
      height: 240px;
      .el-select {
        width: calc(~"100% - 110px");
        margin-right: 10px;
      }
    }
    div.ca:after {
      content: "";
      border-left: 1px solid #ddd;
      height: 200px;
      position: absolute;
      top: 0;
      right: 0;
    }
    div.ewm {
      > div {
        width: 250px;
        text-align: center;
        margin: 0 auto;
        p.qdTitle {
          text-align: left;
        }
      }
      width: 40%;
      float: left;
      img {
        display: block;
        background: #fff;
      }
    }
  }
  table.list {
    width: 100%;
    margin-top: 50px;
    border-collapse: collapse;
    td {
      height: 40px;
      border: 1px solid #ddd;
      padding: 0 10px;
    }
  }
}
#app .xyb .lcNext.el-button {
  display: inline-block;
}
</style>
